module.exports = __webpack_public_path__ + "static/media/favicon-lighthouse710.361d99fe.ico";